import { GET_BOM_FAILURE, GET_BOM_REQUEST, GET_BOM_SUCCESS } from "./bomTypes";

const initialStateForBomReports = {
  loading: false,
  bomReports: [],
  error: "",
};

const getBomReportsReducer = (state = initialStateForBomReports, action) => {
  switch (action.type) {
    case GET_BOM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BOM_SUCCESS:
      return {
        loading: false,
        bomReports: action.payload,
        error: "",
      };
    case GET_BOM_FAILURE:
      return {
        loading: false,
        bomReports: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getBomReportsReducer };
